import { styled } from '@mui/material/styles';
import { Button, Paper, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useCommonTranslation } from '../../hooks/useCommonTranslation';

const PREFIX = 'InternalLoginForm';

const classes = {
  container: `${PREFIX}-container`,
  form: `${PREFIX}-form`,
  title: `${PREFIX}-title`,
  submit: `${PREFIX}-submit`,
  error: `${PREFIX}-error`,
};

const Root = styled(Paper)(({ theme }) => ({
  [`&.${classes.container}`]: {
    width: 305,
    padding: 32,
  },

  [`& .${classes.form}`]: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(4),
  },

  [`& .${classes.title}`]: {
    fontSize: 21,
    fontFamily: 'Bitter',
    fontWeight: 700,
    marginBottom: theme.spacing(2),
  },

  [`& .${classes.submit}`]: {
    marginTop: theme.spacing(4),
  },

  [`& .${classes.error}`]: {
    marginTop: theme.spacing(2),
  },
}));

interface InternalLoginFormProps {
  submit: (data: any, evt: any) => void;
  /** Disables the button while a login is in flight (popup flow). */
  loading?: boolean;
  /** User-facing error from a failed login attempt. */
  error?: string | null;
}

export default function InternalLoginForm({
  submit,
  loading = false,
  error = null,
}: InternalLoginFormProps) {
  const t = useCommonTranslation();
  const { handleSubmit } = useForm();

  return (
    <Root className={classes.container}>
      <Typography className={classes.title}>{t('login.loginTitle')}</Typography>
      <form onSubmit={handleSubmit(submit)} className={classes.form}>
        <Button
          color="primary"
          variant="contained"
          className={classes.submit}
          disabled={loading}
          type="submit">
          {t('login.login')}
        </Button>
        {error && (
          <Typography role="alert" color="error" className={classes.error}>
            {error}
          </Typography>
        )}
      </form>
    </Root>
  );
}
